import {useEffect} from 'react'
import {Flex, Text, Box, Link, useToast} from '@chakra-ui/react'
import {Button, Form, Input, FormProps} from 'antd'
import {CommonColors} from '@utils/CommonStyles'
import {useLocation, useNavigate} from 'react-router-dom'
import {AUTH_ACTION, PATH, SCREEN_TRACKING, STATUS_CODE} from '@utils/Const'
import appRequest from '@apis/app'
import {trackingPage} from '@utils'

const SignUp = ({
  onSubmit,
  setIsLoading,
}: {
  onSubmit: any
  setIsLoading: any
}) => {
  const navigate = useNavigate()
  const toast = useToast()
  const {entry_point, task_id} = useLocation()?.state || {}

  useEffect(() => {
    trackingPage(SCREEN_TRACKING.REGISTER_PAGE)
  }, [])

  const onFinish: FormProps<any>['onFinish'] = async values => {
    setIsLoading(true)
    const data = await appRequest.verifyPhone({
      phone: values?.phone,
      action: AUTH_ACTION.SIGN_UP,
    })
    if (data?.data?.status === STATUS_CODE.SUCCESS) {
      onSubmit(values)
    } else {
      toast({
        title: data.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
    setIsLoading(false)
  }

  return (
    <Box sx={styles.form} w={{base: '100%', md: '480px'}} mx={'16px'}>
      <Flex flexDirection={'column'}>
        <Text sx={styles.title}>Tạo tài khoản</Text>
        <Form
          name="basic"
          layout={'vertical'}
          autoComplete="off"
          onFinish={onFinish}>
          <Form.Item
            label="Họ và tên"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label="Số điện thoại"
            name="phone"
            rules={[
              {required: true, message: 'Số điện thoại không hợp lệ'},
              {min: 10, max: 12, message: 'Số điện thoại không hợp lệ'},
              {pattern: /^[0-9]+$/, message: 'Số điện thoại không hợp lệ'},
            ]}
            validateTrigger="onChange"
            validateFirst>
            <Input />
          </Form.Item>
          <Form.Item style={{marginTop: '30px'}}>
            <Button htmlType="submit" type="primary" style={styles.button}>
              Tiếp tục
            </Button>
          </Form.Item>
          <Text sx={styles.textRegister}>
            Tôi đã có tài khoản?
            <Link
              color="#1890FF"
              onClick={() =>
                navigate(PATH.LOGIN, {state: {entry_point, task_id}})
              }
              ml={'6px'}>
              Đăng nhập ngay
            </Link>
          </Text>
        </Form>
      </Flex>
    </Box>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    backgroundColor: CommonColors.blue1,
  },
  form: {
    flexDirection: 'column',
    backgroundColor: CommonColors.white,
    padding: 8,
    alignItems: 'center',
    borderRadius: '24px',
    justifyContent: 'center',
  },
  button: {
    width: '100%',
    borderRadius: '12px',
    backgroundColor: CommonColors.blue2,
    height: '46px',
  },
  textRegister: {
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'center',
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    textAlign: 'center',
  },
}

export default SignUp
